import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Modal } from "semantic-ui-react";
import Card from "./AlternateCard";
import "./RemindersLayout.css";

const PublicModal = (props) => {
  const [reminders, setReminders] = useState([]);

  useEffect(() => {
    if (props.reminders) {
      const remindersData = props.reminders.map((reminder) => {
        let returnReminder = null;
        const athleteList = [...reminder.athletes];
        athleteList.forEach((athlete) => {
          if (athlete.id === props.id) {
            returnReminder = {
              ...reminder,
              modifiedAt: reminder.modifiedAt.toDate().toTimeString(),
            };
          }
        });
        return returnReminder;
      });
      let savingReminders = remindersData.filter((e) => e);
      setReminders(savingReminders);
    }
  }, [props.reminders, props.id]);
  return (
    <Modal
      closeIcon
      open={props.open}
      onClose={() => props.close()}
      className="reminder-list-modal"
    >
      <Modal.Header>Reminders</Modal.Header>
      <Modal.Content scrolling>
        <div className="reminder-main">
          {reminders.length > 0 &&
            reminders.map((reminder) => <Card reminder={reminder} />)}
          {reminders.length < 1 && (
            <p className="not-found cu-center">There is No Data Right Now</p>
          )}
        </div>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    reminders: state.firestore.ordered.reminders,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "reminders",
        orderBy: ["modifiedAt", "desc"],
      },
    ];
    return firestoreArray;
  })
)(PublicModal);
